module.exports = __webpack_public_path__ + "images/QS_Logo_Black_and_Blue_on_Transparent.svg";